import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LocationSelection.css';

const LocationSelection = () => {
  const navigate = useNavigate();

  const handleSelectLocation = (locationPath) => {
    navigate(locationPath);
  };

  return (
    <div className="location-selection-page">
      <div className="location-selection-page__content">
        <img
          src="/arqzin.png"
          alt="Arqzin Ingressos"
          className="location-selection-page__logo"
        />
        <h1 className="location-selection-page__title">Escolha a unidade</h1>

        <div className="location-selection-page__options">
          <button
            className="location-selection-page__option-card"
            onClick={() => handleSelectLocation('/uberlandia')}
          >
            <img src="/icon-udi-text.png" alt="Uberlândia" />
          </button>

          <button
            className="location-selection-page__option-card"
            onClick={() => handleSelectLocation('/ribeirao-preto')}
          >
            <img src="/icon-rib-text.png" alt="Ribeirão Preto" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationSelection;
